import styled from "styled-components";

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  gap: 1rem;
`;

export const LoadingText = styled.p`
  color: #666;
  font-size: 1.25rem;
  margin: 0;
`;

export const Spinner = styled.svg`
  width: 60px;
  height: 60px;
  color: #b1b6ff;
`;
